"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mStableOpTypes = void 0;
var mStableOpTypes;
(function (mStableOpTypes) {
    mStableOpTypes["Mint"] = "mint";
    mStableOpTypes["Redeem"] = "redeem";
    mStableOpTypes["Swap"] = "swap";
})(mStableOpTypes = exports.mStableOpTypes || (exports.mStableOpTypes = {}));
//# sourceMappingURL=dex-types.js.map